export const API_CLIENT_KEY = '4f588b2b54d0a20f79acd7f0a1325eda4d92372e1e33e6c68d3bf6948cc49702'; // Client-side key
export const DY_HOST = 'https://direct.dy-api.com'; // Client-side US endpoint
export const DY_REQUEST_TIMEOUT = 1000;
export const EXTRA_URL_COOKIE_KEY = 'extraUrlData';

export const DYNAMIC_IMPORTS = {
    mobile: () => import('mobile/modal/ModalMobile.svelte'),
    desktop: () => import('desktop/modal/ModalDesktop.svelte'),
};

export const ENDPOINTS = {
    CUSTOMER_SET_SUBSCRIBE: '/ms/newsletter/v2/email/subscribe',
    CUSTOMER_SET_PHONE_NUMBER: '/ms/newsletter/v2/sms/subscribe',
    CUSTOMER_REFID: '/ms/cordial/contact/refId',
    CUSTOMER_UPDATE_REFID: '/ms/cordial/contact/updateRefId',
    GET_QRCODE: '/bff/qrcode/qrcode',
    GET_PRODUCTS: (storeID: string) => `/ms/elastic/v2/${storeID}/products`,
    GET_PRICE: (productId: number) => `/backend/api/rest/catalog/product/${productId}/price`,
    GET_IS_USER_SUBSCRIBED: '/ms/newsletter/v2/subscriptions/status',
    SET_GENDER_IN_CORDIAL: '/ms/analytics/event/frontend',
    GET_QUOTE: '/backend/optimaxcart/react/getQuote?version=v2.0',
};

export const EXTRA_URL_DATA_STRUCTURE = {
    utm_source: 'utmSource',
    utm_medium: 'utmMedium',
    utm_campaign: 'utmCampaign',
    utm_content: 'utmContent',
    utm_term: 'utmTerm',
    referral: 'referral',
};

export const COOKIE_VALUE = {
    REMINDER_CLOSE: 'CUSTOMER_REMINDER_CLOSE',
    POPUP_CLOSE: 'CUSTOMER_POPUP_CLOSE',
    SUBSCRIBER: 'SUBSCRIBER',
    SUBSCRIBER_CHECK: 'SUBSCRIBER_CHECK',
    IS_FIRST_DAY_SUBSCRIBER: 'IS_FIRST_DAY_SUBSCRIBER',
    SUBSCRIBER_PHONE: 'SUBSCRIBER_BY_PHONE',
    IS_EXIT_SHOW: 'IS_EXIT_SHOW',
    POPUP_SESSION: 'POPUP_SESSION',
} as const;

export const TEMPLATE = {
    CIRCLE: 'circle',
    SQUARE: 'square',
    SQUARE_PRODUCT: 'squareProduct',
    SQUARE_MOBILE: 'squareMobile',
    SQUARE_QUIZ_MOBILE: 'squareQuizMobile',
    SQUARE_WITH_LOGOS_MOBILE: 'squareWithLogosMobile',
    SQUARE_EXIT: 'squareExit',
    SQUARE_EXIT_CART: 'squareExitCart',
    SQUARE_ADA_EXIT: 'squareAdaExit',
    EXP_SQUARE: 'expSquare',
    EXP_SQUARE_MOBILE: 'expSquareMobile',
    IMAGE_MOBILE: 'imageMobile',
    SQUARE_MOBILE_ADVANTAGES: 'squareAdvantagesMobile',
    SQUARE_EXIT_RECOMMENDATIONS: 'squareExitRecommendations',
    SQUARE_GENDER_MOBILE: 'squareGenderMobile',
    SQUARE_DESKTOP_COMMON: 'squareDesktopCommon',
    SQUARE_EXIT_REDESIGN: 'squareExitRedesign',
} as const;

export const VIEW = {
    MAIN: 'main',
    REMINDER: 'reminder',
} as const;

export const STATE = {
    MAIN: 'main',
    SMS: 'sms',
    TYP: 'typ',
    PRIZE: 'prize',
    ALREADY_SUBSCRIBED: 'subscribed',
} as const;

export const POPUP_TYPE = {
    WELCOME: 'welcome',
    EXIT: 'exit',
    TRIGGER: 'trigger',
} as const;

export const ANIMATION_DURATION = {
    MODAL: 175,
    REMINDER: 175,
    CLOSE_BUTTON: 175,
    REMINDER_CLOSE: 200,
    REMINDER_SHOW: 400,
    ANIMATION_THEME: 300,
} as const;

export const CODE = {
    SUCCESSFUL: 200,
    INVALID_EMAIL: 4,
    PREVIOUSLY_SUBSCRIBED: 3,
    ALREADY_SUBSCRIBED: 2,
} as const;

export const BACKGROUND_COLOR = {
    COLORED: 'colored',
    LIGHT: 'light',
    DARK: 'dark',
} as const;

export const ANALYTICS = {
    POPUP_SHOWED: '{{type}}-popup-showed',
    POPUP_SHOWED_TY: 'ty-popup-showed',
    POPUP_SHOWED_SUBSCRIBED: 'subscribed-popup-showed',
    POPUP_SHOWED_SMS: 'popup-sms-showed',
    POPUP_CLOSED: '{{type}}-popup-closed',
    POPUP_CLOSED_SMS: 'popup-sms-closed',
    POPUP_SKIPPED_SMS: 'popup-sms-skipped',
    POPUP_SUBSCRIBED: '{{type}}-popup-subscribed',
    POPUP_SUBSCRIBED_SMS: 'popup-sms-subscribed',
    POPUP_CODE_COPIED_TY: 'ty-popup-code-copied',
    POPUP_CODE_COPIED_SUBSCRIBED: 'subscribed-popup-code-copied',
    REMINDER_SHOWED: 'reminder-showed',
    REMINDER_SHOWED_SMS: 'reminder-sms-showed',
    REMINDER_CLOSED: 'reminder-closed',
    REMINDER_CLOSED_SMS: 'reminder-sms-closed',
    REMINDER_CLICKED: 'reminder-clicked',
    REMINDER_CLICKED_SMS: 'reminder-sms-clicked',
    TYP_QUIZ_BUTTON_CLICKED: 'Quiz CTA',
    SPIN_BUTTON_CLICKED: 'spin-to-win',
    CTA_BUTTON_CLICKED: 'cta clicked',
    REFID_ERROR: 'refid-not-defined',
} as const;

export const FLAGS = {
    YOUTUBE: 'youtubeTest',
    TYP_STEPS: 'typSteps',
    CROSS_WITHOUT_DELAY: 'crossWithoutDelay',
    SESSION: 'session',
    SMS_OLD: 'smsOld',
} as const;

export const PLATFORM = {
    DESKTOP: 'DESKTOP',
    MOBILE: 'MOBILE',
} as const;

export const EXP_DY_REQUEST_TIMEOUT = 1500;
